import { AutoMap } from '@automapper/classes';

export class UserEntity {
    Id?: number;
    @AutoMap()
    Email!: string;
    @AutoMap()
    FirstName!: string;
    @AutoMap()
    LastName!: string;
    @AutoMap()
    Phone!: string;
}
